"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Company = function Company(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M11.636 4.011c.348 0 .631.28.636.628v.732a.468.468 0 010 .066h.619c.347 0 .63.28.635.627v4.185a.32.32 0 01-.319.32h-2.76a.49.49 0 00-.49.476v8.706c0 .124-.1.225-.225.225l-.06-.008a.225.225 0 01-.165-.217v-2.626a.51.51 0 00-.51-.51H7.764a.51.51 0 00-.51.51v2.224a.616.616 0 01-.616.627l-.102-.007a.636.636 0 01-.537-.64V6.064c0-.353.286-.639.639-.639h.615V4.64a.639.639 0 01.639-.628zm4.79 7.153c.26 0 .47.21.47.47v7.872a.47.47 0 01-.47.47h-2.398a.465.465 0 01-.476-.462v-2.423a.376.376 0 00-.376-.376h-.904a.376.376 0 00-.35.376v2.418a.468.468 0 01-.471.467h-.32a.47.47 0 01-.47-.467v-7.874c0-.26.21-.47.47-.47zm-1.164 5.55h-.903a.376.376 0 00-.377.377v.907c0 .207.167.375.374.376h.91a.376.376 0 00.376-.376l-.003-.907a.376.376 0 00-.377-.376zm-2.086-2.057h-.904a.376.376 0 00-.376.376v.904c0 .207.168.376.376.376h.91a.376.376 0 00.376-.376l-.006-.904a.376.376 0 00-.376-.376zm2.086 0h-.903a.376.376 0 00-.377.376v.904c0 .205.165.373.371.376h.91a.376.376 0 00.376-.376v-.904a.376.376 0 00-.377-.376zM9.085 13.29H7.634a.38.38 0 00-.38.38v1.459c.002.209.17.377.38.379h1.46a.38.38 0 00.376-.38L9.46 13.67a.376.376 0 00-.376-.379zm4.09-.696h-.903a.376.376 0 00-.37.377v.903c0 .206.164.374.37.377h.91a.376.376 0 00.376-.377l-.006-.903a.376.376 0 00-.376-.377zm2.087 0h-.903a.376.376 0 00-.377.377v.903c0 .206.165.374.371.377h.91a.376.376 0 00.376-.377v-.903a.376.376 0 00-.377-.377zm-6.177-2.047H7.634a.38.38 0 00-.38.377v1.462c.002.209.17.378.38.38h1.46a.38.38 0 00.376-.38l-.009-1.462a.376.376 0 00-.376-.377zm0-2.742H7.634a.38.38 0 00-.38.376v1.44a.38.38 0 00.38.376h1.45a.376.376 0 00.386-.353L9.46 8.182a.376.376 0 00-.376-.376zm2.76 0h-1.452a.376.376 0 00-.376.376v1.44c0 .208.168.376.376.376h1.451a.38.38 0 00.388-.353l-.009-1.463a.38.38 0 00-.379-.376z"
  }));
};

var _default = (0, _react.forwardRef)(Company);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Company, "Company", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Company.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Company.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();